import { render, staticRenderFns } from "./fieldSpectrum.vue?vue&type=template&id=d4e55ff2&lang=pug&"
import script from "./fieldSpectrum.vue?vue&type=script&lang=js&"
export * from "./fieldSpectrum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports